import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { push } from 'connected-react-router'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Paylink = Loadable({
    loader: () => import('./Paylink'),
    render(loaded, props) {
      const Component = connect((state) => ({
        paylinkState: state.paylinkState,
        siteConfig: state.siteConfig
      }), {
        init, push, submit
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path='/paylink'
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Paylink {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
